/*
 * File: /apps/web/src/enums/cancellationState.js
 * Project: tr-web
 * Created Date: 2021-03-19
 * Author: Raif
 *
 * Copyright (c) 2021 TaskRabbit, Inc
 */
export const cancellationState = {
  dismiss: "dismiss",
  askRepost: "askRepost",
  gatherIkeaRepostParams: "gatherIkeaRepostParams",
  selectReason: "selectReason",
  confirm: "confirm",
  inProgress: "inProgress",
  complete: "complete",
  refreshList: "refreshList",
};
